<template>
  <div class="phrase-overlay" :style="visible ? 'z-index:300010' : 'z-index:-30000; opacity:0'">
    <transition name="fade">
      <div class="export-dialog list-export-dialog bio-slide-setting-dialog" v-if="visible">
        <div class="newmessage-title">
          <span>紹介スライド設定</span>
          <div class="flex-space"></div>
          <div class="newmessage-button" @click="close()">
            <font-awesome-icon :icon="['fal', 'times']" />
          </div>
        </div>
        <div class="export-dialog-box">
          <div class="export-subtitle">インフルエンサー</div>
          <div style="font-size: 13px; line-height: 1.6; margin-bottom: 16px">{{ influencerDisplayText }}</div>
          <div class="bio-slide-measure-field">
            <div class="export-subtitle bio-slide-measure-subtitle">
              施策内容
              <span class="bio-slide-measure-subtitle-note">
                インフルエンサー紹介文・紹介タイトル・おすすめ投稿の選定に使用します。 商材、目的、ターゲット、訴求軸、投稿イメージ、重視条件、NG表現を分かる範囲で入力してください。
              </span>
            </div>
            <div class="bio-slide-measure-example">
              <div class="bio-slide-measure-example-title">記入例</div>
              <pre class="bio-slide-measure-example-body">商材：メンズ向けスキンケア商品のPR
目的：認知拡大とブランド世界観の浸透
ターゲット：20〜40代男性、清潔感や身だしなみに関心がある層
訴求軸：清潔感、自然体、上質感、朝のルーティン
投稿イメージ：顔が見える写真/リール、外出前の使用シーン、商品を自然に持つカット
重視条件：男性フォロワー比率、ファッション親和性、リール再生
NG・注意事項：効果効能や肌改善の断定、競合商品の露出</pre>
            </div>
            <el-input
              type="textarea"
              v-model="measure_content"
              maxlength="500"
              show-word-limit
              :rows="8"
              class="bio-slide-measure-input"
            />
            <div class="bio-slide-ai-note">{{ aiOutputDisclaimerText }}</div>
          </div>
        </div>
        <div class="list-create-footer">
          <div class="flex-space"></div>
          <el-button @click="close()">閉じる</el-button>
          <el-button type="primary" @click="createSlide()" :disabled="!canSubmit || create_loading">
            <div class="flex-row">
              紹介スライド作成
              <div class="loader--mini" v-show="create_loading"></div>
            </div>
          </el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { AI_OUTPUT_DISCLAIMER_TEXT } from "@/utils/aiOutputDisclaimer";

const root = process.env.VUE_APP_API;
const createIntroSlideExportAPI = root + "/api/list/create_intro_slide_export";

const DEFAULT_MEASURE_CONTENT = `商材：
目的：
ターゲット：
訴求軸：
投稿イメージ：
重視条件：
NG・注意事項：`;

export default {
  name: "influencerBioSlideSettingModal",
  props: {
    visible: { type: Boolean, default: false },
    sns_type: { type: String, required: true },
    list_id: { type: Number, required: true },
    checkList: { type: Array, default: () => [] },
    checkListDetail: { type: Array, default: () => [] },
  },
  data() {
    return {
      measure_content: DEFAULT_MEASURE_CONTENT,
      create_loading: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    influencerDisplayText() {
      const names = this.checkListDetail.map((d) => d.account_name).filter(Boolean);
      if (names.length === 0) return "";
      if (names.length <= 3) return names.join("、");
      return `${names.slice(0, 2).join("、")}、他${names.length - 2}名`;
    },
    canSubmit() {
      const trimmed = (this.measure_content || "").trim();
      if (trimmed === "" || trimmed === DEFAULT_MEASURE_CONTENT.trim()) return false;
      return /[\p{L}\p{N}]/u.test(trimmed);
    },
    aiOutputDisclaimerText() {
      return AI_OUTPUT_DISCLAIMER_TEXT;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.measure_content = DEFAULT_MEASURE_CONTENT;
        this.create_loading = false;
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    buildInfluencerIds() {
      return this.checkListDetail.map((d) => String(d.influencer_id));
    },
    createSlide() {
      if (!this.canSubmit || this.create_loading) return;
      this.create_loading = true;
      const params = new URLSearchParams();
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      params.append("list_id", this.list_id);
      params.append("sns_type", this.sns_type);
      params.append("influencer_ids", JSON.stringify(this.buildInfluencerIds()));
      params.append("campaign_text", this.measure_content.trim());

      this.axios.post(createIntroSlideExportAPI, params).then((response) => {
        this.create_loading = false;
        if (response.data.status === "OK") {
          this.$emit("created");
          this.close();
        } else {
          this.$message.error(response.data.message || "作成に失敗しました");
        }
      }).catch(() => {
        this.create_loading = false;
        this.$message.error("エラーが発生しました");
      });
    },
  },
};
</script>

<style scoped>
.bio-slide-setting-dialog {
  width: 600px;
  max-width: calc(100vw - 40px);
}

.bio-slide-measure-field {
  width: 100%;
}

.bio-slide-measure-subtitle {
  display: block;
  align-items: unset;
  line-height: 1.6;
  margin-bottom: 0;
}

.bio-slide-measure-subtitle-note {
  margin-left: 0.35em;
  font-weight: 400;
  font-size: 11px;
}

.bio-slide-ai-note {
  margin-top: 10px;
  font-size: 11px;
}

.bio-slide-measure-example {
  margin: 1em 0 12px;
  padding: 0;
  background: none;
  border: none;
}

.bio-slide-measure-example-title {
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 400;
  color: #909399;
}

.bio-slide-measure-example-body {
  margin: 0;
  font-family: inherit;
  font-size: 11px;
  line-height: 1.6;
  color: #909399;
  white-space: pre;
  overflow-x: auto;
  background: none;
  border: none;
  padding: 0;
}

.bio-slide-measure-input {
  width: 100%;
}
</style>
